var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-table",
    {
      attrs: {
        data: _vm.tableData,
        height: "100%",
        border: true,
        "tooltip-effect": "dark",
        "header-cell-style": { color: "#333333", background: "#EFF6FF" },
      },
    },
    [
      _c("el-table-column", {
        attrs: {
          prop: "sku_code",
          width: "100px",
          align: "center",
          label: "货号",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "product_title",
          width: "150px",
          align: "center",
          label: "商品名称",
        },
      }),
      _c("el-table-column", {
        attrs: { prop: "supplier_name", align: "center", label: "供应商名称" },
      }),
      _c("el-table-column", {
        attrs: { prop: "create_time", align: "center", label: "添加时间" },
      }),
      _c("el-table-column", {
        attrs: { prop: "owner_name", align: "center", label: "添加人" },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "quantity",
          align: "center",
          width: "70px",
          label: "件数",
        },
      }),
      _c("el-table-column", {
        attrs: { prop: "deduction_amt", align: "center", label: "扣款金额" },
      }),
      _c("el-table-column", {
        attrs: { prop: "video_list", align: "center", label: "视频证据" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _c(
                  "span",
                  {
                    staticClass: "pointer font-weight",
                    staticStyle: { color: "#1389ae" },
                    on: {
                      click: function ($event) {
                        return _vm.onHandleShow(scope.row)
                      },
                    },
                  },
                  [_vm._v("查看证据")]
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: { prop: "qc_type_line", align: "center", label: "问题原因" },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "remarks",
          align: "center",
          label: "缺少斤数*毛单价",
          "min-width": "150",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                _vm._v(
                  " " +
                    _vm._s(scope.row.weight) +
                    "*" +
                    _vm._s(scope.row.weight_price) +
                    " "
                ),
              ]
            },
          },
        ]),
      }),
      _c("el-table-column", {
        attrs: {
          prop: "remarks",
          align: "center",
          label: "备注",
          width: "300",
        },
      }),
      _c("el-table-column", {
        attrs: { prop: "operate_name", align: "center", label: "审核人" },
      }),
      _c("el-table-column", {
        attrs: { prop: "state_txt", align: "center", label: "审核状态" },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "audit_time",
          align: "center",
          label: "审核时间",
          width: "150",
        },
      }),
      _c("el-table-column", {
        attrs: {
          prop: "deduction_time",
          align: "center",
          label: "扣款时间",
          width: "150",
        },
      }),
      _c("el-table-column", {
        attrs: { label: "操作", align: "center", fixed: "right", width: "200" },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (scope) {
              return [
                scope.row.state == _vm.EXAMINE_STATUS_ENUM["0"].value
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.onEditGood(scope.row)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    )
                  : _vm._e(),
                _vm.is_audit &&
                scope.row.state == _vm.EXAMINE_STATUS_ENUM["0"].value
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.onToExamine(scope.row)
                          },
                        },
                      },
                      [_vm._v("审核")]
                    )
                  : _vm._e(),
                scope.row.state == _vm.EXAMINE_STATUS_ENUM["0"].value
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: {
                          click: function ($event) {
                            return _vm.openCancelRemark(scope.row)
                          },
                        },
                      },
                      [_vm._v("作废")]
                    )
                  : _vm._e(),
                _c(
                  "el-button",
                  {
                    attrs: { type: "text" },
                    on: {
                      click: function ($event) {
                        return _vm.onHandleViewLog(scope.row)
                      },
                    },
                  },
                  [_vm._v("操作日志")]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }